import { APP_INITIALIZER } from '@angular/core';
import { AuthService } from './services/auth.service';
import { TenantResolutionService } from './services/tenant-resolution.service';

function initializeBffAuth(authService: AuthService, tenantResolution: TenantResolutionService) {
  // Run profile fetch and tenant resolution in parallel — tenant resolution
  // must finish before the first login redirect, but it doesn't block on auth.
  return () => Promise.all([authService.fetchProfile(), tenantResolution.resolve()]);
}

export const bffAuthProviders = [
  {
    provide: APP_INITIALIZER,
    useFactory: initializeBffAuth,
    multi: true,
    deps: [AuthService, TenantResolutionService],
  },
];
